var win = window;

export var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };



//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/raf.js
// module id = 319
// module chunks = 2